import React from 'react'
import cn from 'classnames'
import type { As } from '../../types'
import { Column } from './Column'
import { buildClasses } from './helpers'
import { Collection } from './types'

type Alignment = 'start' | 'center' | 'end' | 'stretch'
type Gutters = 'default' | 'compact' | 'none' | 'horizontal'
type Justification = 'start' | 'center' | 'end' | 'between' | 'around'

type RowProps = {
  children: React.ReactNode | React.ReactNode[]
  as?: As
  alignItems?: Alignment | Collection<Alignment>
  gutters?: Gutters
  justifyContent?: Justification | Collection<Justification>
}

const alignItemsClasses = buildClasses<Alignment>('align-items')
const justifyContentClasses = buildClasses<Justification>('justify-content')

export const Row = ({
  children,
  as: Element = 'div',
  alignItems,
  gutters = 'default',
  justifyContent,
}: RowProps) => {
  const gutterClasses = {
    none: 'no-gutters',
    compact: 'small-gutters',
    default: '',
    comfortable: 'large-gutters',
    horizontal: 'no-vertical-gutters',
  }
  const classes = cn(
    'row',
    [
      ...alignItemsClasses(alignItems),
      ...justifyContentClasses(justifyContent),
    ],
    {
      [gutterClasses[gutters]]: gutters,
    },
  )

  React.Children.forEach(children, (child) => {
    if (React.isValidElement(child) && child.type === Column) return

    throw new Error('Row component can only have Column components as children')
  })

  return <Element className={classes}>{children}</Element>
}
